import React, { Suspense } from 'react';
import CircularProgress from '../../../components/CircularProgress';

const ClientMarketingList = React.lazy(() => import('../components/ClientMarketingList'));
function ClientMarketingListView(props: any) {
  return (
    <Suspense fallback={<CircularProgress />}>
      <ClientMarketingList {...props} />
    </Suspense>
  );
}

export default ClientMarketingListView;
